export const TAG_MANAGER_ID = "GTM-WB64LTWJ";

export function analyticsBootstrap(measurementId: string | null) {
  return `window.dataLayer=window.dataLayer||[];window.gtag=window.gtag||function(){window.dataLayer.push(arguments);};${measurementId ? `gtag('set','developer_id.dZjgwMW',true);gtag('js',new Date());gtag('config',${JSON.stringify(measurementId)},{send_page_view:false});` : ""}(function(w,d,s,l,i){if(d.getElementById('aleph-gtm'))return;w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.id='aleph-gtm';j.async=true;j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);})(window,document,'script','dataLayer',${JSON.stringify(TAG_MANAGER_ID)});`;
}

let lastPageLocation: string | undefined;

export function trackPageView(measurementId: string | null) {
  if (!measurementId || typeof window === "undefined") return;
  const analyticsWindow = window as Window & { gtag?: (...args: unknown[]) => void };
  if (!analyticsWindow.gtag || lastPageLocation === window.location.href) return;
  lastPageLocation = window.location.href;
  analyticsWindow.gtag("event", "page_view", {
    send_to: measurementId,
    page_path: window.location.pathname + window.location.search,
    page_location: window.location.href,
    page_title: document.title,
  });
}